export default function returnQueryParams(canvasActive = false) {
  if (window.location.search === "") return [];
  try {
    const urlParams = canvasActive ? window.parent.location.search : window.location.search;
    return urlParams
      .replace('?', '')
      .split('&')
      .map(param => param.split('='))
      .reduce((values, [ key, value ]) => {
        values[ key ] = decodeURIComponent(value)
        return values
      }, {});
  } catch {
    console.log("Query params are blocked due to cross origin");
    return {}
  }
}
